import { Star, Quote } from "lucide-react";

// Vrais avis Google de LLDLS (4.9/5 - 91 avis)
const TESTIMONIALS = [
  {
    name: "Laura",
    date: "Octobre 2025",
    rating: 5,
    text: "Entreprise super sérieuse. Travail de qualité et suivi régulier. Mention spéciale pour Mr Paterakis Christophe qui est super réactif aux demandes des clients et surtout super gentil. Notre toiture est juste magnifique ! On recommande sans hésitation !",
    initials: "LA",
    project: "Rénovation toiture"
  },
  {
    name: "Amélie",
    date: "Mai 2025",
    rating: 5,
    text: "Un grand merci à Denis et son équipe ! Travail rapide, efficace, et surtout très propre ! Ouvriers très respectueux et agréables. Et merci à Christophe pour ces précieux conseils et explications. Nous vous recommandons les yeux fermés !",
    initials: "AM",
    project: "Toiture + Velux"
  },
  {
    name: "Christopher",
    date: "Avril 2025",
    rating: 5,
    text: "Un immense merci à Thomas et toute son équipe pour leur professionnalisme et leur sérieux. Un travail impeccable, réalisé avec soin et précision : aucune trace après leur passage. Un suivi exemplaire du début à la fin. Je recommande les yeux fermés.",
    initials: "CH",
    project: "Rénovation complète"
  }
];

const Testimonials = () => {
  return (
    <section id="temoignages" className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-amber-100 text-amber-700 px-4 py-2 rounded-full text-sm font-medium mb-4">
            <Star className="w-4 h-4 fill-amber-500" />
            4.9/5 sur Google Avis (91 avis)
          </div>
          <h2 className="font-heading text-3xl sm:text-4xl font-bold text-slate-900 mb-4">
            Ce que disent nos clients
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            Des avis authentiques de propriétaires en Wallonie et Brabant Wallon
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {TESTIMONIALS.map((testimonial, index) => (
            <div
              key={index}
              className="bg-slate-50 rounded-2xl p-8 animate-fade-in relative"
              style={{ animationDelay: `${index * 0.1}s` }}
              data-testid={`testimonial-${index}`}
            >
              {/* Project Type Badge */}
              <div className="absolute -top-3 left-6">
                <span className="bg-slate-900 text-white text-xs font-medium px-3 py-1 rounded-full">
                  {testimonial.project}
                </span>
              </div>

              {/* Google Badge */}
              <div className="flex items-center justify-between mb-4 mt-2">
                <div className="flex gap-1">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} className="w-5 h-5 fill-amber-400 text-amber-400" />
                  ))}
                </div>
                <span className="text-xs text-slate-400 flex items-center gap-1">
                  <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none">
                    <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
                    <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
                    <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
                    <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
                  </svg>
                  Google
                </span>
              </div>

              {/* Quote */}
              <blockquote className="text-slate-700 leading-relaxed mb-6">
                "{testimonial.text}"
              </blockquote>

              {/* Author */}
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-slate-900 flex items-center justify-center text-white font-semibold text-sm">
                    {testimonial.initials}
                  </div>
                  <div>
                    <div className="font-semibold text-slate-900">{testimonial.name}</div>
                    <div className="text-xs text-slate-500">{testimonial.date}</div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Stats Bar with Project Breakdown */}
        <div className="mt-16 bg-slate-900 rounded-2xl p-8 md:p-12">
          <div className="text-center mb-8">
            <h3 className="font-heading text-2xl font-bold text-white mb-2">350+ projets réalisés</h3>
            <p className="text-slate-400">Notre expertise couvre tous vos besoins en rénovation énergétique</p>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
            <div>
              <div className="font-heading text-3xl font-bold text-white">180</div>
              <div className="text-slate-400 mt-1 text-sm">Installations<br />photovoltaïques</div>
            </div>
            <div>
              <div className="font-heading text-3xl font-bold text-white">75</div>
              <div className="text-slate-400 mt-1 text-sm">Toitures<br />rénovées</div>
            </div>
            <div>
              <div className="font-heading text-3xl font-bold text-white">50</div>
              <div className="text-slate-400 mt-1 text-sm">Pompes à<br />chaleur</div>
            </div>
            <div>
              <div className="font-heading text-3xl font-bold text-amber-500">4.9/5</div>
              <div className="text-slate-400 mt-1 text-sm">Note Google<br />91 avis</div>
            </div>
          </div>
        </div>

        {/* Link to Google Reviews */}
        <div className="mt-8 text-center">
          <a 
            href="https://www.google.com/search?q=LLDLS+toiture+avis" 
            target="_blank" 
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-slate-600 hover:text-amber-600 transition-colors"
          >
            <span>Voir tous nos avis sur Google</span>
            <span>→</span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
